import get from "lodash/get";
import { useQuery } from "react-query";

import * as Api from "../api";
import * as Constants from "../constants";
import * as Mappers from "../mappers";

const usePairs = ({ params }) => {
  const initialData = { pairs: {}, meta: Mappers.Meta() };

  const paramsWithDefaults = {
    search: params?.search || 0,
    page: params?.page ? params.page : 1,
    perPage: params?.perPage || 5,
    name: params?.name || [],
  };

  const { data = initialData, ...args } = useQuery(
    [
      Constants.ENTITY_PAIRS,
      "all",
      paramsWithDefaults.page,
      paramsWithDefaults.perPage,
      paramsWithDefaults.search,
    ],
    async () => {
      const { data } = await Api.PairsList({ params: paramsWithDefaults });

      const pairs = Object.fromEntries(
        Object.entries(get(get(data, "data"), "pairs") || {}).map(
          ([groupName, items]) => [groupName, items.map(Mappers.AiSearchPairs)],
        ),
      );

      const meta = Mappers.Meta(data.data);

      return { pairs, meta };
    },
    { initialData, keepPreviousData: true },
  );

  return { ...data, ...args };
};

export default usePairs;
